import { ICosmeticsAssessmentUrlParams } from './types';

/**
 * Endpoint that is used to retrieve the devices list from the backend that was
 * received from apple.
 */
export const deviceImageUploadsListUrl = ({
  assessmentType,
  sessionId,
}: ICosmeticsAssessmentUrlParams) =>
  `b2b/asset-condition/auto-assessment/log/${sessionId}?assessmentType=${assessmentType}`;

/**
 * Endpoint used for capturing posting the image details which the backend will
 * then post to apple.
 */
export const deviceImageUploadUrl = () =>
  'b2b/asset-condition/auto-assessment/image/upload';

/**
 * Validates with the server that all the images have been uploaded successfully.
 * @deprecated
 */
export const doneUploadingImageUrl = () => 'as/auto-assessment/image/done';

/**
 * Endpoint used for validating the Evaluation ID
 * Read more: https://northladder.atlassian.net/wiki/spaces/BTS/pages/2472378369/Used+Device+Trade-In+Integration+for+Pandas+WebApp
 */
export const deviceAssessmentValidateEvaluationIdUrl = (evaluationId: string) =>
  `b2b/appraisal/nl-assessment/${evaluationId}/validate`;

/**
 * Endpoint used for submitting the assessment results
 */
export const deviceAssessmentResultsUrl = () =>
  'b2b/appraisal/nl-assessment/assessments';
